import { GuardedComponent } from '../components/guarded-component';
import { DUXInspectionRequestPage } from '../features/dux-inspection-request/dux-inspection-request.page';
import { UserPermissionName } from '../models/user-permission-name';

export const DUXInspectionRequestRoute = {
  path: '/dux-inspection-request',
  name: 'DUX Inspection Request',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_DUX_INSPECTION_REQUESTS]} showPermissionError>
          <DUXInspectionRequestPage />
        </GuardedComponent>
      ),
    },
  ],
};
